<template>
    <img
        src="~/assets/icon/icon-search-dark.svg"
        alt=""
    />
</template>
